import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';

async function getToken(token: string) {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/invite/validate/${token}`);

  return data;
}

export default function useValidateTokenQuery(token: string) {
  const toast = useToast();

  const query = useQuery({
    queryKey: getKey(token),
    queryFn: () => getToken(token),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    enabled: !!token,
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(token: string) {
  return ['Token', token] as const satisfies QueryKey;
}
useValidateTokenQuery.getKey = getKey;
